import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 25px;
`;

export const Title = styled.h5``;

export const BoxWrapper = styled.div`
  width: 100%;
  @media all and (min-width: 1000px) {
    display: flex;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid #ddd;
`;

export const ItemTitle = styled.div`
  width: 30%;
  background-color: #e8e8e8;
  text-align: center;
  padding: 10px 15px;
  border-right: 1px solid #ddd;
  font-weight: bold;
`;

export const ItemValue = styled.div`
  width: 70%;
  padding: 10px 15px;
  ${(props) => props.color && `color: ${props.color};`}
`;
